module.exports = __webpack_public_path__ + "static/img/logo-t.4460e7a.png";